import React from "react";
import ProductsPageLayout from "./ProductsPageLayout";

export default function Sofa() {
  return (
    <>
      <ProductsPageLayout productCategory="sofa" />
    </>
  );
}
